export const PENDING = 'pending';
export const UNSEEN = 'unseen';
export const DONE = 'done';
export const ERR = 'error';
